import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lightning } from "@phosphor-icons/react";
import { errText } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback({ onAuthed }) {
    const location = useLocation();
    const navigate = useNavigate();
    // useRef (not useState) so StrictMode's double-mount doesn't fire the exchange twice.
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;

        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        const exchange = async () => {
            try {
                const backend = process.env.REACT_APP_BACKEND_URL;
                const { data } = await axios.post(
                    `${backend}/api/auth/session`,
                    { session_id: sessionId },
                    { withCredentials: true }
                );
                // Clear the hash so a refresh doesn't retry.
                window.history.replaceState({}, "", "/");
                onAuthed?.(data);
                navigate("/", { replace: true, state: { user: data } });
            } catch (e) {
                const msg = errText(e, "Sign-in failed");
                toast.error(msg);
                navigate("/login", { replace: true });
            }
        };
        exchange();
    }, [location.hash, navigate, onAuthed]);

    return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-center">
            <Lightning size={26} weight="bold" className="text-klein animate-pulse" />
            <div className="mt-4 font-mono uppercase tracking-widest text-[11px] font-bold text-ink">
                Signing you in…
            </div>
        </div>
    );
}
